<template>
  <div class="driverDetail">
    <!-- <el-drawer
      size="50%"
      title="设置车队名称"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <basic-container> -->
      <div class="group-title">基本信息</div>
        <!-- <div style="display:flex;align-items:center;margin-bottom:16px;">
          <label for="plots" style="width:80px;text-align:right;">模式：</label>
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="2">选择模式</el-checkbox>
            <el-checkbox label="1">输入模式</el-checkbox>
          </el-checkbox-group>
        </div> -->
        <div style="display:flex;" class="group-form">
            <label for="plots" style="width:80px;text-align:right;white-space: nowrap">车队名称：</label>
             <div class="tags" style="margin:20px 0px">
         

          <el-tag  v-for="(tag,index) in tags" :key="index" closable @close="handleClose(index)" style="margin-right:6px;margin-bottom: 6px">
            {{ tag }}
          </el-tag>
          <el-button type="primary"
            plain
            class="add-tag" @click="openDialog" size="small" 
            >新增车队</el-button
          >
          <!-- <el-input id="plots" v-model.trim="plotsName" style="width:300px" maxlength="15" size="small" placeholder="请输入车队名称" @keyup.enter.native="addTag">

            <el-button slot="suffix" @click="addTag" size="small" type="text" >新增车队</el-button>
          </el-input> -->
        </div>
        </div>
       
       
        <div class="btns" style="text-align: center; margin-top: 20px">
          <!-- <el-button @click="cancelModal" size="small" style="margin-left: 20px"
            >取 消</el-button> -->
          <el-button type="primary" size="small" :loading="btnLoading"  @click="handleUpdate"
            >保存</el-button>
        </div>
        <el-dialog
      width="548px"
      :close-on-click-modal="false"
      v-if="tagVisible"
      :visible.sync="tagVisible"
    >
      <template slot="title">
        <div class="check-title">
          <i class="el-icon-info" style="color: #35b1ff; margin-right: 8px"></i>
          添加车队名称
        </div>
      </template>
      <div class="dialog-content">
        <el-input
          v-model="plotsName"
          placeholder="请输入车队名称"
        ></el-input>
        <div class="err-tip">{{ tagErrTxt }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tagVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTag">保存</el-button>
      </div>
    </el-dialog>
      <!-- </basic-container>
    </el-drawer> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {updProFleetNames,getProjectInfoExt} from "@/api/chain/projectinfo";
export default {
  props:['info'],
  data() {
    return {
      tagVisible:false,
      tagErrTxt:"",
      btnLoading: false,
      plotsName:'',
      tags:[],
      checkList:['1'],
      // info:{}
    };
  },
  created() {},
  mounted() {
    // this.info = JSON.parse(this.$route.query.info);
    this.getProjectInfoExt()
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    openDialog(){
      this.plotsName=""
      this.tagVisible=true
    },
    getProjectInfoExt(){
      getProjectInfoExt(this.info.id).then(res=>{
        this.tags = res.data.data.fleetNames&&res.data.data.fleetNames.split(",")||[]
        this.checkList = res.data.data.fleetNameModelType=="0"?["1","2"]:res.data.data.fleetNameModelType=="2"?["2"]:["1"]
      })
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
    addTag(){
      if(!this.plotsName) return false
      if(this.tags.includes(this.plotsName)){
        this.tagErrTxt="已有相同的车队名称"
      }else{
        this.tags.push(this.plotsName)
        this.tagVisible=false
      }
    },
    handleClose(index){
      this.tags.splice(index,1)
    },
    handleUpdate() {
      // if(this.checkList.length==0){
      //   this.$message.error("请选择模式")
      //   return false
      // }
      this.btnLoading = true;
      // debugger
      updProFleetNames({
        projectInfoId: this.info.id,
        fleetNameModelType:this.checkList.length==2?0:this.checkList.includes("1")?1:this.checkList.includes("2")?2:"",
        fleetNames: this.tags.join(","),
      })
        .then((res) => {
          this.$message.success("保存成功")
          this.btnLoading = false;
          // this.$emit("update:visible", false);
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.group-title {
  font-weight: 500;
  font-size: 16px;
  color: #313133;
  margin-bottom: 16px;
}
.driverDetail {
  position: relative;
  height: calc(100vh - 300px);
  margin-left: 20px;
  margin-top: 20px;
}
/deep/ .el-drawer__header {
  margin-bottom: 10px;
}
.group-form {
  margin-left: 68px;
  label {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
}
.btns {
  position: absolute;
  left: 0;
  right: 0;
  padding-top: 8px;
  bottom: -12px;
  border-top: 1px solid #ededf0;
}
/deep/.tags{
  margin: 0!important;
}
.dialog-content {
  margin-left: 30px;
  .err-tip {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    color: #e60026;
  }
  /deep/.el-input--medium .el-input__inner {
    height: 48px;
    line-height: 48px;
  }
}
/deep/.el-dialog__footer {
  background: #fff;
  justify-content: flex-end;
  margin-right: 20px;
}
</style>
